import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import neonTheme from './theme/neonTheme';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import PasswordProtection from './components/PasswordProtection';

// Wrapper component to use navigate inside Router context
function LoginWrapper() {
  const navigate = useNavigate();
  
  const handleLogin = (data) => {
    console.log('Login data:', data);
    // Navigate to dashboard with user data in state
    navigate('/app', { state: { emiratesId: data.emiratesId, name: data.name } });
  };
  
  return <Login onLogin={handleLogin} />;
}

function SignupWrapper() {
  const navigate = useNavigate();
  return <Signup onSignup={() => navigate('/app')} />;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={neonTheme}>
      <CssBaseline />
      <PasswordProtection>
        <BrowserRouter
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true
          }}
        >
          <Routes>
            <Route path="/" element={<LoginWrapper />} />
            <Route path="/signup" element={<SignupWrapper />} />
            <Route path="/app" element={<Dashboard />} />
          </Routes>
        </BrowserRouter>
      </PasswordProtection>
    </ThemeProvider>
  </React.StrictMode>
);
